/**
 * Prefix for cache keys.
 */
export const PREFIX = "WORKAROUND_LOCAL_CACHE";
